import * as constAction from 'root/actionConstants';

export const clear = (value) => ({
  type: constAction.DISPOSITIVO_CLEAR,
  payload: value,
});

export const setState = (values) => ({
  type: constAction.DISPOSITIVO_SET_STATE,
  payload: values,
});

export const get = () => ({
  type: constAction.DISPOSITIVO_GET,
  epic: {
    url: 'dispositivos/getAll',
    method: 'GET',
  },
});

export const getCodigo = () => ({
  type: constAction.DISPOSITIVO_GET_CODIGO,
  epic: {
    url: 'dispositivos/getCodigo',
    method: 'GET',
  },
});

export const delete_ = (dispositivoId) => ({
  type: constAction.DISPOSITIVO_DELETE,
  state: {
    id: dispositivoId,
  },
  payload: {
    dispositivoId,
  },
  epic: {
    url: 'dispositivos/eliminar',
    method: 'POST',
  },
});

export const accept = (dispositivoId) => ({
  type: constAction.DISPOSITIVO_ACCEPT,
  payload: {
    dispositivoId,
    aceptado: true,
  },
  epic: {
    url: 'dispositivos/aceptar',
    method: 'POST',
  },
});

export const requestAction = (task, dispositivoId) => ({
  type: constAction.DISPOSITIVO_REQUEST_ACTION,
  payload: {
    task,
    dispositivoId,
  },
  epic: {
    url: 'dispositivoTasks/requestAction',
    method: 'POST',
  },
});

export const getFullDispositivo = (dispositivoId) => ({
  type: constAction.DISPOSITIVO_GET_FULL,
  payload: {
    dispositivoId,
  },
  epic: {
    url: 'dispositivos/getFull',
    method: 'GET',
  },
});

export const getMoreTasks = (dispositivoId, count) => ({
  type: constAction.DISPOSITIVO_GET_MORE_TASKS,
  payload: {
    dispositivoId,
    count,
  },
  epic: {
    url: 'dispositivoTasks/getTasks',
    method: 'GET',
  },
});

export const getPhotoUrl = (taskId) => ({
  type: constAction.DISPOSITIVO_GET_PHOTO_URL,
  payload: {
    taskId,
  },
  epic: {
    url: 'dispositivoTasks/getPhotoUrl',
    method: 'GET',
  },
});



// WEBPACK FOOTER //
// src/modules/dispositivos/action.js